// @ts-expect-error moduleResolution:nodenext issue 54523
import { html, nothing } from 'lit';
// @ts-expect-error moduleResolution:nodenext issue 54523
import { customElement, property, state } from 'lit/decorators.js';
import LightElement from './light-element.js';

@customElement('product-viewer-open-button-message')
export default class ProductViewerOpenButtonMessage extends LightElement {

	@property({ type: String })
	productId: string;

	@state()
	quantity: number = 0;

	connectedCallback() {
		super.connectedCallback();
		this.checkIfShouldSync();
		document.addEventListener('updateAddedProducts', this.checkIfShouldSync.bind(this));
	}

	disconnectedCallback() {
		super.disconnectedCallback();
		document.removeEventListener('updateAddedProducts', this.checkIfShouldSync.bind(this));
	}

	private checkIfShouldSync() {
		if (!(<any>window).addedProducts) {
			return;
		}
		const found = (<any>window).addedProducts.filter((product) => product.id === this.productId);
		if (found.length) {
			let totalQuantity = 0;
			for (let i = 0; i < found.length; i++) {
				const currentProduct = found[i];
				totalQuantity+= currentProduct.quantity;
			}
			this.quantity = totalQuantity;
		} else {
			this.quantity = 0;
		}
	}

	render() {
		if (!this.quantity) {
			return nothing;
		}
		return html`<p class="c-add-product__message" role="status" data-test="upsell-product-added-to-your-basket">${this.quantity.toString()} added to <a href="/basket" class="c-add-product__message-link">your basket</a></p>`;
	}

}
